import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import PropTypes from "prop-types";
import { usePinnedFilterState } from "./usePinnedFilterState";

const muiDefaultFilter = createFilterOptions({ matchFrom: "any", limit: 500 });

/**
 * MUI multiple Autocomplete with the same "pin filter / clear on blur" behavior as
 * {@link CustomAutocomplete}, for in/notIn with large option lists (no Select All row).
 */
export default function PinnedFilterMuiMultiSelect(props) {
  const { onChange } = props;
  const rest = { ...props };
  delete rest.onChange;
  delete rest.filterOptions;
  const {
    filterValue,
    effectiveFilter,
    handleInputChange,
    createOnCloseHandler,
    afterListItemSelection,
  } = usePinnedFilterState();

  return (
    <Autocomplete
      {...rest}
      onChange={(event, newValue) => {
        afterListItemSelection();
        onChange(event, newValue);
      }}
      inputValue={filterValue}
      onInputChange={handleInputChange}
      onClose={createOnCloseHandler()}
      filterOptions={(options, state) =>
        muiDefaultFilter(options, {
          ...state,
          inputValue: effectiveFilter || state.inputValue,
        })
      }
    />
  );
}

PinnedFilterMuiMultiSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  filterOptions: PropTypes.func,
};
